import Swiper from "swiper";
import "swiper/css/navigation";
import { Navigation, Autoplay } from 'swiper/modules';

export default function swiperPropertyQuickView() {
    const swipers = document.querySelectorAll('.swiper-testimonials');

    if(swipers.length == 0) return;

    swipers.forEach((e) => {
        const swiperOptions = {
            modules: [Navigation, Autoplay],
            slidesPerView: 1,
            slidesPerColumn: 1,
            spaceBetween: 0,
            speed: 1000,
            loop: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        };
        const swiperInstance = new Swiper(e, swiperOptions);
    });

}
